// extracted by mini-css-extract-plugin
export default {"sidebarContent":"IssueSidebar-module__sidebarContent__Oa_PXIi","copilotAssignmentButton":"IssueSidebar-module__copilotAssignmentButton__WvRzWXQ"};